import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaCar, FaShieldAlt, FaLandmark, FaFileInvoiceDollar, FaUserTie, FaChartBar } from 'react-icons/fa';

const AdminDashboard = () => {
  const navigate = useNavigate();

  const features = [
    { title: 'Dealership Branding', path: '/profile', description: 'Configure official Dealership Name, upload high-res brand logo image, and update showroom address & fees.', icon: FaLandmark, color: 'from-cyan-500 to-blue-600' },
    { title: 'Cars', path: '/d2-cars', description: 'Manage inventory, stock numbers, vehicle metadata, and pricing details.', icon: FaCar, color: 'from-blue-500 to-cyan-500' }, 
    { title: 'F&I Services', path: '/d2-fandi', description: 'Configure financial protection packages, warranty products, and optional coverages.', icon: FaShieldAlt, color: 'from-emerald-500 to-teal-500' }, 
    { title: 'Lenders', path: '/d2-lenders', description: 'Set up financial institutional partners, configure base parameters, and toggle active status.', icon: FaLandmark, color: 'from-indigo-500 to-blue-500' }, 
    { title: 'Lender Plans', path: '/d2-lender-plans', description: 'Define rates, terms, specific credit requirements, and financing guidelines.', icon: FaFileInvoiceDollar, color: 'from-purple-500 to-pink-500' }, 
    { title: 'Salespersons', path: '/d2-salespersons', description: 'Manage sales staff accounts, assign credentials, and track user profiles.', icon: FaUserTie, color: 'from-violet-500 to-purple-500' }, 
    { title: 'Reports', path: '/d2-reports', description: 'Analyze performance statistics, monthly sales volumes, gross profits, and inventory asset valuation.', icon: FaChartBar, color: 'from-amber-500 to-orange-500' }
  ];

  return (
    <div className="p-8 h-full w-full bg-slate-50/50 flex flex-col overflow-y-auto animate-fade-in-up">
      {/* Welcome Banner */}
      <div className="mb-8 p-8 rounded-3xl bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 text-white shadow-xl relative overflow-hidden">
        <div className="absolute right-0 top-0 w-96 h-96 bg-primary-600/10 rounded-full blur-3xl -mr-20 -mt-20"></div>
        <div className="relative z-10">
          <span className="px-3 py-1 bg-white/10 backdrop-blur-md rounded-full text-xs font-semibold uppercase tracking-wider text-slate-200">
            Portal Administration
          </span>
          <h1 className="text-3xl font-extrabold text-white mt-4 tracking-tight">Dealer Admin Dashboard</h1>
          <p className="text-slate-400 mt-2 max-w-xl text-sm leading-relaxed font-normal">
            Manage your inventory, lender parameters, financial products, dealership staff accounts, and check analytics performance metrics.
          </p>
        </div>
      </div>

      {/* Grid Features */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {features.map(feature => {
          const Icon = feature.icon;
          return (
            <div 
              key={feature.title} 
              onClick={() => navigate(feature.path)}
              className="group bg-white hover:bg-slate-50/80 p-6 rounded-2xl border border-slate-200/60 shadow-sm flex flex-col justify-between cursor-pointer hover:shadow-lg hover:-translate-y-1 transition-all duration-300 relative overflow-hidden"
            >
              <div>
                <div className={`w-12 h-12 rounded-xl bg-gradient-to-br ${feature.color} flex items-center justify-center text-white mb-5 shadow-md shadow-slate-100 group-hover:scale-110 transition-all duration-300`}>
                  <Icon size={20} />
                </div>
                <h2 className="text-xl font-bold text-slate-800 tracking-tight group-hover:text-indigo-600 transition-colors">{feature.title}</h2>
                <p className="text-slate-500 text-xs mt-2 leading-relaxed font-normal">{feature.description}</p>
              </div>
              <div className="mt-6 flex items-center text-xs font-semibold text-indigo-600 group-hover:text-indigo-700">
                Manage {feature.title.toLowerCase()} <span className="ml-1 group-hover:translate-x-1 transition-transform">&rarr;</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AdminDashboard;
